import { useEffect, useState } from 'react';
import { Amplify } from 'aws-amplify';
import { getCurrentUser, signIn, signOut } from 'aws-amplify/auth';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import OverviewPage from './components/OverviewPage';
import CustomerDetail from './components/CustomerDetail';
import UsagePage from './components/UsagePage';
import Header from './components/Header';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId:       process.env.REACT_APP_COGNITO_USER_POOL_ID,
      userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
      loginWith: { email: true },
    }
  }
});

export default function App() {
  const [user, setUser]   = useState(null);
  const [loading, setLoad] = useState(true);
  const [email, setEmail]  = useState('');
  const [pass, setPass]    = useState('');
  const [err, setErr]      = useState('');

  useEffect(() => {
    getCurrentUser()
      .then(setUser)
      .catch(() => setUser(null))
      .finally(() => setLoad(false));
  }, []);

  async function handleLogin(e) {
    e.preventDefault();
    setErr('');
    try {
      await signIn({ username: email, password: pass });
      const u = await getCurrentUser();
      setUser(u);
    } catch (error) {
      setErr('Kullanıcı adı veya şifre hatalı.');
    }
  }

  async function handleLogout() {
    await signOut();
    setUser(null);
  }

  if (loading)
    return (
      <div className='min-h-screen flex items-center justify-center bg-slate-100'>
        <p className='text-slate-400'>Yükleniyor...</p>
      </div>
    );

  if (!user)
    return (
      <div className='min-h-screen flex items-center justify-center bg-slate-100'>
        <div className='bg-white rounded-2xl shadow-lg p-10 w-full max-w-sm'>
          <h1 className='text-2xl font-bold text-slate-800 mb-1'>Cloud4Feed</h1>
          <p className='text-sm text-slate-500 mb-6'>Log Monitoring</p>
          <form onSubmit={handleLogin} className='flex flex-col gap-4'>
            <input
              type='email'
              placeholder='@acsight.com e-posta'
              value={email}
              onChange={e => setEmail(e.target.value)}
              className='border border-gray-200 rounded-lg px-4 py-2 text-sm
                         focus:outline-none focus:ring-2 focus:ring-blue-500'
            />
            <input
              type='password'
              placeholder='Şifre'
              value={pass}
              onChange={e => setPass(e.target.value)}
              className='border border-gray-200 rounded-lg px-4 py-2 text-sm
                         focus:outline-none focus:ring-2 focus:ring-blue-500'
            />
            {err && <p className='text-red-500 text-xs'>{err}</p>}
            <button type='submit'
              className='bg-blue-600 hover:bg-blue-700 text-white rounded-lg
                         py-2 text-sm font-medium transition-colors'>
              Giriş Yap
            </button>
          </form>
        </div>
      </div>
    );

  return (
    <BrowserRouter>
      <div className='min-h-screen bg-slate-50'>
        <Header user={user} onLogout={handleLogout} />
        <div className='max-w-7xl mx-auto px-4 py-8'>
          <Routes>
            <Route path='/'                     element={<OverviewPage />} />
            <Route path='/usage'                element={<UsagePage />} />
            <Route path='/musteri/:musteri'     element={<CustomerDetail />} />
            <Route path='*'                     element={<Navigate to='/' />} />
          </Routes>
        </div>
      </div>
    </BrowserRouter>
  );
}